import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Flame, X } from "lucide-react";

/** Gentle banner for signed-in creators whose share streak expires today. */
export default function StreakNudge() {
  const { user } = useAuth();
  const [streak, setStreak] = useState(null);
  const [hidden, setHidden] = useState(() => !!sessionStorage.getItem("streak_nudge_hidden"));

  useEffect(() => {
    if (!user || hidden) return;
    api.get("/me/streak").then((r) => setStreak(r.data)).catch(() => {});
  }, [user, hidden]);

  if (!user || hidden || !streak || streak.shared_today || streak.current_streak < 1) return null;

  const dismiss = () => {
    sessionStorage.setItem("streak_nudge_hidden", "1");
    setHidden(true);
  };

  return (
    <div
      className="max-w-[1400px] mx-auto px-6 md:px-10 pt-6"
      data-testid="streak-nudge"
    >
      <div className="border border-[#ff6b35]/50 bg-[#140c08] px-5 py-3 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 min-w-0">
          <Flame size={16} className="text-[#ff6b35] flex-shrink-0" />
          <span className="font-mono text-xs text-[#e8d5c4]">
            Your <span className="text-[#ff6b35] font-bold">{streak.current_streak}-day share streak</span> expires
            tonight — share any of your coins to keep the flame alive.
          </span>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/my-coins"
            data-testid="streak-nudge-cta"
            className="btn-brutal bg-[#ff6b35] text-[#050505] font-bold uppercase tracking-wider text-[11px] px-4 py-2"
          >
            Share now →
          </Link>
          <button onClick={dismiss} data-testid="streak-nudge-dismiss" aria-label="Dismiss" className="text-[#d0d0d0] hover:text-white">
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
